import React from 'react'
import { Link } from 'react-router-dom'
import { Form, Button, Row, Col } from 'antd';
import { ConsentFormStep1 } from './Step1.js';
import { ConsentFormStep2 } from './Step2.js';
import { ConsentFormStep3aPatient } from './Step3aPatient.js';
import { ConsentFormStep3aPatientEmail } from './Step3aPatientEmail';
import { ConsentFormStep3aSurrogate } from './Step3aSurrogate';
import { ConsentFormStep3aSurrogateEmail } from './Step3aSurrogateEmail';
import { ConsentFormStep3aRegainedCapacity } from './Step3aRegainedCapacity';
import { ConsentFormStep3aRegainedCapacityEmail } from './Step3aRegainedCapacityEmail';
import { ConsentFormStep3b } from './Step3b.js';
import { ConsentFormStep4 } from './Step4.js';
import SignatureCanvas from 'react-signature-canvas'


class Consent extends React.Component {


    handleSubmit = (e) => {
        e.preventDefault();

        this.props.form.validateFields((err, values) => {
            if (!err) {
                values['currentStepInt'] = this.props.currentStepInt
                values['currentStep'] = this.props.currentStep

                this.props.handleSubmit(values)
            }
        });
    };

    handleNext = (e) => {
        e.preventDefault();

        this.props.form.validateFields((err, values) => {
            if (!err) {
                values['currentStepInt'] = this.props.currentStepInt
                values['currentStep'] = this.props.currentStep

                if (values['currentStep'] === 'Step 3a') {
                    if ((this.props.consentMethodType !== 'Email' && this.props.consentMethodType !== 'EmailRegainedCapacity') || this.props.token) {
                      values['signature'] = this.sigPad.getTrimmedCanvas().toDataURL('image/png');

                      if (this.witnessSigPad) {
                        values['witnessSignature'] = this.witnessSigPad.getTrimmedCanvas().toDataURL('image/png');
                      }

                      this.props.handleSigChange(values['signature'])
                      this.props.handleWitnessSigChange(values['witnessSignature'])
                    }

                    if (!this.props.token) {
                      values['investigatorSignature'] = this.investigatorSigPad.getTrimmedCanvas().toDataURL('image/png')
                    }

                    this.props.handleInvestigatorSigChange(values['investigatorSignature'])
                } else if (values['currentStep'] === 'Step 3b') {
                    this.props.handleFileChange(values['consentFile'])
                }

                this.props.handleNext(values)

            }
        });
    };


    previousButton() {
      let {currentStep, currentStepType } = this.props;
      if ( (currentStep === 'Step 2') || (currentStep === 'Step 3a') || (currentStep === 'Step 3b') ) {
        return (<React.Fragment>
            {(currentStepType !== 'step2patientEmail') && <Form.Item>
                <Button style={{ color: '#FAFAFA'}} size='large' type="button" loading={this.props.loading} className='btn-submit' onClick={this.props.handlePrev}>
                    Back
                </Button>
            </Form.Item>}
        </React.Fragment>)
      }

      return null;
    }

    nextButton(){
      let {currentStep, currentStepInt} = this.props
      if ( (currentStep === 'Step 1') || (currentStep === 'Step 2') ) {
        return (
            <Form.Item>
                <Button style={{ color: '#FAFAFA'}} size='large' type="button" loading={this.props.loading} className='btn-submit' onClick={this.handleNext}>
                    Next
                </Button>
            </Form.Item>
        )
      } else if ( (currentStep === 'Step 3a') || (currentStep === 'Step 3b') ) {
        return (
            <Form.Item>
                <Button style={{ color: '#FAFAFA'}} size='large' type="button" loading={this.props.loading} className='btn-submit' onClick={this.handleNext}>
                    Submit
                </Button>
            </Form.Item>
        )
      }

      return null;
    }


   signatureCanvas() {
        const { getFieldDecorator } = this.props.form
        let { currentStep, currentStepInt, consentMethodType, currentStepType } = this.props;

        if (currentStep === 'Step 3a') {
            return(
                <div>
                  {((consentMethodType !== 'Email' && consentMethodType !== 'EmailRegainedCapacity') || currentStepType === 'step2patientEmail') && <Form.Item>

                            <label>
                                <h5>
                               Participant/Legally Authorized Representative Signature
                                </h5>
                                <SignatureCanvas clearOnResize={false} penColor='black' id="Signature" name="Signature"
                                 canvasProps={{backgroundColor: 'rgba(250,250,250,10)', className: 'signature-canvas'}} ref={(ref) => { this.sigPad = ref }}  />

                             </label>

                    </Form.Item>}

                  {(consentMethodType !== 'Email' && consentMethodType !== 'EmailRegainedCapacity') && <Form.Item>

                            <label>
                                <h5>
                               Witness Signature
                                </h5>
                                <SignatureCanvas clearOnResize={false} penColor='black' id="witnessSignature" name="witnessSignature"
                                 canvasProps={{backgroundColor: 'rgba(250,250,250,10)', className: 'signature-canvas'}} ref={(ref) => { this.witnessSigPad = ref }}  />

                             </label>

                    </Form.Item>}

                  {currentStepType !== 'step2patientEmail' && <Form.Item>

                            <label>
                                <h5>
                               Investigator/Delegate Signature
                                </h5>
                                <SignatureCanvas clearOnResize={false} penColor='black' id="investigatorSignature" name="investigatorSignature"
                                 canvasProps={{backgroundColor: 'rgba(250,250,250,10)', className: 'signature-canvas'}} ref={(ref) => { this.investigatorSigPad = ref }}  />

                             </label>

                    </Form.Item>}

                    {((consentMethodType !== 'Email' && consentMethodType !== 'EmailRegainedCapacity') || currentStepType === 'step2patientEmail') && <Form.Item>
                        <button style={{ color: '#FAFAFA'}} size='large' type="button" loading={this.props.loading} className='btn-submit' onClick={(e) => {this.sigPad.clear();}}>
                            Clear Participant/Surrogate Signature
                        </button>
                    </Form.Item>}
                    {(consentMethodType !== 'Email' && consentMethodType !== 'EmailRegainedCapacity') && <Form.Item>
                        <button style={{ color: '#FAFAFA'}} size='large' type="button" loading={this.props.loading} className='btn-submit' onClick={(e) => {this.witnessSigPad.clear();}}>
                            Clear Witness Signature
                        </button>
                    </Form.Item>}
                    {currentStepType !== 'step2patientEmail' && <Form.Item>
                        <button style={{ color: '#FAFAFA'}} size='large' type="button" loading={this.props.loading} className='btn-submit' onClick={(e) => {this.investigatorSigPad.clear();}}>
                            Clear Investigator Signature
                        </button>
                    </Form.Item>}
                </div>
            )
        }
   }

    render() {
        const { getFieldDecorator } = this.props.form;
        const ConsentFormStep3aPatientComponent = this.props.consentMethodType === 'Email' ? ConsentFormStep3aPatientEmail : ConsentFormStep3aPatient;
        const ConsentFormStep3aSurrogateComponent = this.props.consentMethodType === 'Email' ? ConsentFormStep3aSurrogateEmail : ConsentFormStep3aSurrogate;
        const ConsentFormStep3aRegainedCapacityComponent = this.props.consentMethodType === 'EmailRegainedCapacity' ? ConsentFormStep3aRegainedCapacityEmail : ConsentFormStep3aRegainedCapacity;

        return (
            <Row type='flex' justify='center'>
                <Col xs={24} sm={18} md={18} lg={20} xl={22} className='frosted-card'>
                    <h2> Consent - {this.props.currentStep}</h2>
                    <Form onSubmit={this.handleSubmit}>

                                          {/*
                                            Step 1 - user enters userID, siteID, subjectID
                                            Step 2 - verifies that userID, siteID are valid, that the subject exists, and if they already have consent entered
                                                     also asks for consentPersonType and consentMethodType
                                            Step 3a - paper consent form with download link and upload button; Patient and Surrogate versions
                                            Step 3b - electronic consent form
                                            Step 4 - Confirmation of consent process and Link to view stored document
                                          */}
                                          <ConsentFormStep1
                                            consentDate={this.props.consentDate}
                                            currentStep={this.props.currentStep}
                                            currentStepInt={this.props.currentStepInt}
                                            handleChange={this.props.handleChange}
                                            subjectID={this.props.subjectID}
                                            userID={this.props.userID}
                                            siteID={this.props.siteID}
                                            loading={this.props.loading}
                                            getFieldDecorator={getFieldDecorator}
                                          />
                                          <ConsentFormStep2
                                            consentExistsEmailStatus={this.props.consentExistsEmailStatus}
                                            consentDate={this.props.consentDate}
                                            currentStep={this.props.currentStep}
                                            currentStepInt={this.props.currentStepInt}
                                            handleChange={this.props.handleChange}
                                            subjectID={this.props.subjectID}
                                            userID={this.props.userID}
                                            siteID={this.props.siteID}
                                            consentType={this.props.consentType}
                                            consentPersonType={this.props.consentPersonType}
                                            consentMethodType={this.props.consentMethodType}
                                            consentExists={this.props.consentExists}
                                            consentExistsOverwrite={this.props.consentExistsOverwrite}
                                            consentExistsLink={this.props.consentExistsLink}
                                            consentExistsType={this.props.consentExistsType}
                                            consentExistsPersonType={this.props.consentExistsPersonType}
                                            consentExistsMethodType={this.props.consentExistsMethodType}
                                            consentExistsDate={this.props.consentExistsDate}
                                            loading={this.props.loading}
                                            getFieldDecorator={getFieldDecorator}
                                          />
                                          <ConsentFormStep3aPatientComponent
                                            participantEmail={this.props.participantEmail}
                                            consentExistsDate={this.props.consentExistsDate}
                                            consentDate={this.props.consentDate}
                                            currentStep={this.props.currentStep}
                                            currentStepInt={this.props.currentStepInt}
                                            handleChange={this.props.handleChange}
                                            handleDatePickerChange={this.props.handleDatePickerChangeChange}
                                            handleSigChange={this.props.handleSigChange}
                                            handleWitnessSigChange={this.props.handleWitnessSigChange}
                                            handleInvestigatorSigChange={this.props.handleInvestigatorSigChange}
                                            subjectID={this.props.subjectID}
                                            userID={this.props.userID}
                                            siteID={this.props.siteID}
                                            consentType={this.props.consentType}
                                            consentPersonType={this.props.consentPersonType}
                                            consentMethodType={this.props.consentMethodType}
                                            fullName={this.props.fullName}
                                            dateOfBirth={this.props.dateOfBirth}
                                            signature={this.props.signature}
                                            witnessSignature={this.props.witnessSignature}
                                            witnessFullName={this.props.witnessFullName}
                                            investigatorSignature={this.props.investigatorSignature}
                                            investigatorFullName={this.props.investigatorFullName}
                                            date={this.props.date}
                                            consentProvided={this.props.consentProvided}
                                            consentOption={this.props.consentOption}
                                            consentSaved={this.props.consentSaved}
                                            consentSavedLink={this.props.consentSavedLink}
                                            submitted={this.props.submitted}
                                            currentStepType={this.props.currentStepType}
                                            loading={this.props.loading}
                                            getFieldDecorator={getFieldDecorator}
                                            has_randomization_platform_step_3_patient={this.props.has_randomization_platform_step_3_patient}
                                            randomization_platform_step_3_patient_content={this.props.randomization_platform_step_3_patient_content}
                                          />
                                          <ConsentFormStep3aSurrogateComponent
                                            participantEmail={this.props.participantEmail}
                                            consentExistsDate={this.props.consentExistsDate}
                                            consentDate={this.props.consentDate}
                                            currentStep={this.props.currentStep}
                                            currentStepInt={this.props.currentStepInt}
                                            handleChange={this.props.handleChange}
                                            handleDatePickerChange={this.props.handleDatePickerChangeChange}
                                            handleSigChange={this.props.handleSigChange}
                                            handleWitnessSigChange={this.props.handleWitnessSigChange}
                                            handleInvestigatorSigChange={this.props.handleInvestigatorSigChange}
                                            subjectID={this.props.subjectID}
                                            userID={this.props.userID}
                                            siteID={this.props.siteID}
                                            consentType={this.props.consentType}
                                            consentPersonType={this.props.consentPersonType}
                                            consentMethodType={this.props.consentMethodType}
                                            fullName={this.props.fullName}
                                            dateOfBirth={this.props.dateOfBirth}
                                            signature={this.props.signature}
                                            witnessSignature={this.props.witnessSignature}
                                            witnessFullName={this.props.witnessFullName}
                                            representativeFullName={this.props.representativeFullName}
                                            investigatorSignature={this.props.investigatorSignature}
                                            investigatorFullName={this.props.investigatorFullName}
                                            date={this.props.date}
                                            consentProvided={this.props.consentProvided}
                                            consentOption={this.props.consentOption}
                                            consentSaved={this.props.consentSaved}
                                            consentSavedLink={this.props.consentSavedLink}
                                            submitted={this.props.submitted}
                                            currentStepType={this.props.currentStepType}
                                            loading={this.props.loading}
                                            getFieldDecorator={getFieldDecorator}
                                            has_randomization_platform_step_3_surrogate={this.props.has_randomization_platform_step_3_surrogate}
                                            randomization_platform_step_3_surrogate_content={this.props.randomization_platform_step_3_surrogate_content}
                                          />
                                          <ConsentFormStep3aRegainedCapacityComponent
                                            participantEmail={this.props.participantEmail}
                                            consentExistsDate={this.props.consentExistsDate}
                                            consentDate={this.props.consentDate}
                                            currentStepType={this.props.currentStepType}
                                            currentStep={this.props.currentStep}
                                            currentStepInt={this.props.currentStepInt}
                                            handleChange={this.props.handleChange}
                                            handleDatePickerChange={this.props.handleDatePickerChangeChange}
                                            handleSigChange={this.props.handleSigChange}
                                            handleWitnessSigChange={this.props.handleWitnessSigChange}
                                            handleInvestigatorSigChange={this.props.handleInvestigatorSigChange}
                                            subjectID={this.props.subjectID}
                                            userID={this.props.userID}
                                            siteID={this.props.siteID}
                                            consentType={this.props.consentType}
                                            consentPersonType={this.props.consentPersonType}
                                            consentMethodType={this.props.consentMethodType}
                                            fullName={this.props.fullName}
                                            dateOfBirth={this.props.dateOfBirth}
                                            signature={this.props.signature}
                                            witnessSignature={this.props.witnessSignature}
                                            witnessFullName={this.props.witnessFullName}
                                            representativeFullName={this.props.representativeFullName}
                                            investigatorSignature={this.props.investigatorSignature}
                                            investigatorFullName={this.props.investigatorFullName}
                                            date={this.props.date}
                                            consentProvided={this.props.consentProvided}
                                            consentOption={this.props.consentOption}
                                            consentSaved={this.props.consentSaved}
                                            consentSavedLink={this.props.consentSavedLink}
                                            submitted={this.props.submitted}
                                            loading={this.props.loading}
                                            getFieldDecorator={getFieldDecorator}
                                            has_randomization_platform_step_3_patient_regained_capacity={this.props.has_randomization_platform_step_3_patient_regained_capacity}
                                            randomization_platform_step_3_patient_regained_capacity_content={this.props.randomization_platform_step_3_patient_regained_capacity_content}
                                          />
                                          <ConsentFormStep3b
                                            currentStep={this.props.currentStep}
                                            currentStepInt={this.props.currentStepInt}
                                            handleChange={this.props.handleChange}
                                            subjectID={this.props.subjectID}
                                            userID={this.props.userID}
                                            siteID={this.props.siteID}
                                            consentType={this.props.consentType}
                                            consentPersonType={this.props.consentPersonType}
                                            consentMethodType={this.props.consentMethodType}
                                            date={this.props.date}
                                            fileDummyRequest={this.props.fileDummyRequest}
                                            normFile={this.props.normFile}
                                            consentFile={this.props.consentFile}
                                            handleFileChange={this.props.handleFileChange}
                                            fileList={this.props.fileList}
                                            dataset={this.props.dataset}
                                            consentProvided={this.props.consentProvided}
                                            consentPaperBlankLink={this.props.consentPaperBlankLink}
                                            consentPaperUpload={this.props.consentPaperUpload}
                                            consentSaved={this.props.consentSaved}
                                            consentSavedLink={this.props.consentSavedLink}
                                            submitted={this.props.submitted}
                                            loading={this.props.loading}
                                            getFieldDecorator={getFieldDecorator}
                                          />
                                          <ConsentFormStep4
                                            token={this.props.token}
                                            currentStep={this.props.currentStep}
                                            currentStepInt={this.props.currentStepInt}
                                            handleChange={this.props.handleChange}
                                            subjectID={this.props.subjectID}
                                            userID={this.props.userID}
                                            siteID={this.props.siteID}
                                            consentType={this.props.consentType}
                                            consentPersonType={this.props.consentPersonType}
                                            consentMethodType={this.props.consentMethodType}
                                            fullName={this.props.fullName}
                                            dateOfBirth={this.props.dateOfBirth}
                                            signature={this.props.signature}
                                            witnessSignature={this.props.witnessSignature}
                                            witnessFullName={this.props.witnessFullName}
                                            investigatorSignature={this.props.investigatorSignature}
                                            investigatorFullName={this.props.investigatorFullName}
                                            date={this.props.date}
                                            consentPaperBlankLink={this.props.consentPaperBlankLink}
                                            consentPaperUpload={this.props.consentPaperUpload}
                                            consentExistsPersonType={this.props.consentExistsPersonType}
                                            consentExistsMethodType={this.props.consentExistsMethodType}
                                            consentExistsEmailStatus={this.props.consentExistsEmailStatus}
                                            consentExists={this.props.consentExists}
                                            consentExistsLink={this.props.consentExistsLink}
                                            consentSaved={this.props.consentSaved}
                                            consentSavedLink={this.props.consentSavedLink}
                                            submitted={this.props.submitted}
                                            loading={this.props.loading}
                                            getFieldDecorator={getFieldDecorator}
                                          />


                                        {this.signatureCanvas()}

                                        {this.nextButton()}
                                        {this.previousButton()}


{ /*
                                        <Form.Item>
                                            <Button size='large' type="primary" loading={this.props.loading} htmlType="submit" className='btn-submit'>
                                                Upload
                                            </Button>
                                        </Form.Item>
*/}
                    </Form>
                      <p>&nbsp;</p>
                      <h5>or select one of the following options:</h5>
                      <ul>
                        <li><Link to='/' style={{ color: '#FAFAFA', width: '12rem' }} className='menu-item'> Home </Link></li>
                      </ul>


                </Col>
            </Row>
        )
    }
}


const ConsentForm = Form.create()(Consent);

export default ConsentForm;



// WEBPACK FOOTER //
// ./src/components/ConsentTypeRedDeerCalgary/Consent.js